import { AppointmentSlotSchedulePatient, AppointmentStatus } from '@dreryk/egabinet-appointment-frontend-api';
import { VisitStatus } from '@dreryk/egabinet-visit-frontend-api';

import { FluidTabs } from '@dreryk/react-components';

import visitSettlement from '../../../../../visitSettlement';
import { useAppointmentDetailsFluidTab } from '../details/useAppointmentDetailsFluidTab';

type AppointmentContextDialogTabsProps = {
   readonly patient: AppointmentSlotSchedulePatient;
   readonly appointmentId: number;
   readonly practitionerId: number;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly visitId: number | undefined;
   readonly appointmentStatus: AppointmentStatus;
   readonly visitStatus: VisitStatus | undefined;
   readonly onEventChange: VoidFunction;
   readonly onClose: VoidFunction;
   readonly ownedByCurrentUser: boolean;
   readonly timeSlotConfirmed: boolean;
};

export const AppointmentContextDialogTabs = (props: AppointmentContextDialogTabsProps): JSX.Element => {
   return (
      <FluidTabs testId={'appointment'}>
         {useAppointmentDetailsFluidTab({
            onClose: props.onClose,
            visitId: props.visitId,
            onVisitAlreadyStartedFault: props.onEventChange,
            onAppointmentAlreadyCancelledFault: props.onEventChange,
            appointmentId: props.appointmentId,
            beginDate: props.beginDate,
            endDate: props.endDate,
            onAppointmentCancelled: props.onEventChange,
            patientId: props.patient.id,
            appointmentStatus: props.appointmentStatus,
            visitStatus: props.visitStatus,
            onAppointmentUpdated: props.onEventChange,
            timeSlotConfirmed: props.timeSlotConfirmed,
         })}
         {visitSettlement.useVisitSettlementCalendarFluidTab({
            appointmentId: props.appointmentId,
            onClose: props.onClose,
            ownedByCurrentUser: props.ownedByCurrentUser,
            practitionerId: props.practitionerId,
            beginDate: props.beginDate,
            endDate: props.endDate,
            patient: props.patient,
         })}
      </FluidTabs>
   );
};
